import { render, staticRenderFns } from "./YetkiGecisiEkrani.vue?vue&type=template&id=f371c868&scoped=true"
import script from "./YetkiGecisiEkrani.vue?vue&type=script&lang=ts"
export * from "./YetkiGecisiEkrani.vue?vue&type=script&lang=ts"
import style0 from "./YetkiGecisiEkrani.vue?vue&type=style&index=0&id=f371c868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f371c868",
  null
  
)

export default component.exports